const Resume= () => {
    return (
      <section id="resume" className="main-container">
      <aside className="main-header">
        <h2>Resume</h2>
      </aside>
      <article className="main-body flex-column">
       <p>Here is a downloadable link to my resume: <a href="/files/ChrisKimballResumeApr2022_WORKING.pdf" target="_blank" download>Resume</a>.</p>
       <p>Feel free to reach out to me on <a href="https://www.linkedin.com/in/chriskimball1" target="_blank" rel="noreferrer">LinkedIn</a> to learn more, or if you would like to collaborate on a project reach out to me on <a href="https://github.com/chriskimball" target="_blank" rel="noreferrer">Github</a>.</p>
      </article>
    </section>
    );
  }
  
  export default Resume;
  